import React from 'react';

import s from './Description.module.scss';

const Description = () => {

    return (
        <div className={s.description}>
            <h2>Карточки</h2>
            <p>Изучая слова не забывайте тренировать и память. Эта игра предложит Вам карточки, где перевернуть за раз можно две. Ваша задача найти соответствующие
                карточки. Игра следит какие карточки были перевернуты. Открыв первую карточку, Вы должны указать соответствующую вторую. Если вторая карточка была 
                ранее перевернута, но Вы её не указали, игра засчитает неверный ответ и подсветит обе карты красным.</p>
        </div>
    )

};

export default Description;